import { render, staticRenderFns } from "./PeiControversy.vue?vue&type=template&id=1eb1d270&"
import script from "./PeiControversy.vue?vue&type=script&lang=js&"
export * from "./PeiControversy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports